export default __webpack_public_path__ + "ebd86bc0e48f5d95896267d3757204e5.svg";